import { LoadState } from '../+types/load-state.type';
import { RenderState } from '../../../types/RenderState.type';
import { PdfViewerPageLayer } from '../components/pdf-viewer-page/pdf-viewer-page.component.type';
export var PageActionType;
(function (PageActionType) {
    PageActionType["Load"] = "Load";
    PageActionType["Render"] = "Render";
})(PageActionType || (PageActionType = {}));
export class PageLoadAction {
    constructor(payload) {
        this.payload = payload;
        this.type = PageActionType.Load;
    }
}
export class PageRenderAction {
    constructor(payload) {
        this.payload = payload;
        this.type = PageActionType.Render;
    }
}
export function shouldRerenderPdfCanvasLayerForPage(page) {
    return page.scale !== page.pdfCanvasRenderedAtScale;
}
export function shouldRerenderPdfEmbeddedMediaLayerForPage(page) {
    return page.scale !== page.pdfEmbeddedMediaCanvasRenderedAtScale;
}
export function determinePageAction(pagesInDescendingOrderOfPriority) {
    for (let page of pagesInDescendingOrderOfPriority) {
        // If a page is not loaded
        if (page.loadState === LoadState.None) {
            return new PageLoadAction({ page });
        }
        // If a page is loading return
        if (page.loadState === LoadState.Loading) {
            return;
        }
        // If a page is failed continue
        if (page.loadState === LoadState.Failed) {
            continue;
        }
        const requiredLayersRenderState = page.requiredLayersRenderState;
        const requiredLayersRenderStates = Array.from(requiredLayersRenderState.values());
        // If a page layer is rendering return
        if (requiredLayersRenderStates.includes(RenderState.Running)) {
            return;
        }
        const layerToRender = Array.from(requiredLayersRenderState.keys()).find(layer => {
            const layerRenderState = requiredLayersRenderState.get(layer);
            // If a layer is at initial state, it still has to render
            if (layerRenderState === RenderState.Initial) {
                return true;
            }
            // If the Pdf canvas was rendered or is rendering for an outdated zoom factor, render page!
            if (layer === PdfViewerPageLayer.PdfCanvas) {
                if (shouldRerenderPdfCanvasLayerForPage(page)) {
                    return true;
                }
            }
            // If the Pdf embedded media canvas was rendered or is rendering for an outdated zoom factor, render page!
            if (layer === PdfViewerPageLayer.PdfEmbeddedMedia) {
                if (shouldRerenderPdfEmbeddedMediaLayerForPage(page)) {
                    return true;
                }
            }
            // When a layer finished or failed nothing to do anymore
            if (layerRenderState === RenderState.Failed || layerRenderState === RenderState.Finished) {
                return false;
            }
            throw new Error('Unexpected render state');
        });
        if (layerToRender) {
            return new PageRenderAction({ page, layer: layerToRender });
        }
        // Just move to next page
    }
}
//# sourceMappingURL=pdf-viewer-layout-helper.js.map